import React, { useEffect } from 'react';
import { MotionConfig } from 'framer-motion';
import { initMetaPixel, trackPixelEvent } from './utils/metaPixel';
import { PRICE_VALUE, PRODUCT_NAME } from './data/config';
import { tomes } from './data/kit';
import { TopBar } from './components/TopBar';
import { Hero } from './components/Hero';
import { VideoTour } from './components/VideoTour';
import { KitOverview } from './components/KitOverview';
import { TomeSection } from './components/TomeSection';
import { Bonuses } from './components/Bonuses';
import { TwoOptions } from './components/TwoOptions';
import { PainPoints } from './components/PainPoints';
import { EmotionalTransition } from './components/EmotionalTransition';
import { OfferCountdown } from './components/OfferCountdown';
import { MainOffer } from './components/MainOffer';
import { FAQ } from './components/FAQ';
import { CostComparison } from './components/CostComparison';
import { EmotionalClose } from './components/EmotionalClose';
import { FinalOffer } from './components/FinalOffer';
import { Footer } from './components/Footer';
import { MobileBuyBar } from './components/MobileBuyBar';
import { PurchaseNotification } from './components/PurchaseNotification';
export function App() {
  useEffect(() => {
    initMetaPixel();
    trackPixelEvent('ViewContent', {
      content_name: PRODUCT_NAME,
      content_type: 'product',
      value: PRICE_VALUE,
      currency: 'ARS'
    });
  }, []);
  return <MotionConfig reducedMotion="user" data-id="element-0" data-mp="2zn6b4vo3kbmp">
      <div className="min-h-screen w-full bg-brand-cream font-sans text-brand-ink selection:bg-brand-orange/30 selection:text-brand-violet" data-id="element-1" data-mp="33m5ck6amdq9e">
        <TopBar data-id="element-2" data-mp="38k6wsujs7vmg" />
        <Hero data-id="element-3" data-mp="38nupxslbeg0n" />
        <main className="pb-[calc(88px+env(safe-area-inset-bottom))] md:pb-0" data-id="element-4" data-mp="3dkuws5pznmst">
          <VideoTour data-id="element-5" data-mp="3dirw8rr7mb9u" />
          <KitOverview data-id="element-6" data-mp="nvj1lae5u4n3" />
          <TomeSection tome={tomes[0]} tone="white" data-id="element-7" data-mp="nwc0jp6vnpuo" />
          <TomeSection tome={tomes[1]} tone="cream" reverse data-id="element-8" data-mp="nxwxflgnzkvp" />
          <Bonuses data-id="element-9" data-mp="stc8k5naf2of" />
          <TwoOptions data-id="element-10" data-mp="sssrss9dikbz" />
          <PainPoints data-id="element-11" data-mp="36hwt7ylgu1r" />
          <EmotionalTransition data-id="element-12" data-mp="35yo8huu3i0e" />
          <OfferCountdown data-id="element-13" data-mp="356wxj89s6fx" />
          <MainOffer data-id="element-14" data-mp="38ktuby5znfz" />
          <FAQ data-id="element-15" data-mp="3ud1glcmeruc7" />
          <CostComparison data-id="element-16" data-mp="3udknzzefn0bz" />
          <EmotionalClose data-id="element-17" data-mp="3ubzvsgflbtha" />
          <FinalOffer data-id="element-18" data-mp="3uevui6z9im6s" />
        </main>
        <Footer data-id="element-19" data-mp="d57fh2ybeij2" />
        <MobileBuyBar data-id="element-20" data-mp="d3mmhhrnf7nb" />
        <PurchaseNotification data-id="element-21" data-mp="d3wdn8ofjkul" />
      </div>
    </MotionConfig>;
}